import {createFileRoute, redirect} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/u/")({
    // TODO: Complete this with real redirections
    loader: async ({context}) => {

        if (context.availableWorkspaces.length === 0 && context.invitedWorkspaces.length === 0) {
            throw redirect({
                to: "/u/select-workspace",
            });
        }

        if (context.availableWorkspaces.length === 1 && context.invitedWorkspaces.length === 0) {
            const workspaceId = context.availableWorkspaces[0]?.id;
            if (workspaceId === undefined) {
                // This should never happen
                throw new Error("Workspace ID is undefined");
            }
            throw redirect({
                to: "/w/$workspaceId",
                params: {
                    workspaceId: workspaceId,
                },
            });
        }

        if (context.invitedWorkspaces.length > 0) {
            throw redirect({
            to: "/u/select-workspace",
        });
        }

        throw redirect({
            to: "/u/select-workspace",
        });
    },
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
